export default __webpack_public_path__ + "1ae938ece47fdbb20bf7481d686ac1c3.svg";